// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-1som","content":"styles_content__3vr0G"};